export default function VisualBreak() {
  return (
    <section className="relative w-full h-[55vh] sm:h-[65vh] md:h-[70vh] min-h-[320px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/5ee516f09f857f69e3e4972600b025bd.jpg"
        alt="Rustic Copper artisan workshop"
        className="w-full h-full object-cover object-center"
        style={{ transform: "scale(1.05)" }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/20 to-black/50" />

      {/* Quote */}
      <div className="absolute bottom-8 sm:bottom-14 left-5 sm:left-14 right-5 sm:right-auto">
        <div className="flex items-center gap-4 sm:gap-5 mb-3 sm:mb-4">
          <div className="w-6 sm:w-8 h-px bg-[#D4AF87]" />
          <p
            className="text-[#D4AF87] text-[10px] uppercase tracking-[4px]"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            The Craft
          </p>
        </div>
        <p
          className="text-white text-2xl sm:text-3xl md:text-4xl italic max-w-sm sm:max-w-md leading-relaxed"
          style={{ fontFamily: "Playfair Display, serif", fontWeight: 400 }}
        >
          Every piece tells a story.
        </p>
      </div>
    </section>
  );
}
